import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SESSION_STORAGE_KEYS } from "./constants";
import { enResources } from "AttendanceForm/TextFiles/translations";

export const local_keys = [
  SESSION_STORAGE_KEYS.LOGOUT_COMPLETE_LABEL,
  SESSION_STORAGE_KEYS.LOGOUT_COMPLETE_DIALOG,
  SESSION_STORAGE_KEYS.LOGIN_BACK,
  SESSION_STORAGE_KEYS.HERE,
  SESSION_STORAGE_KEYS.NOT_AUTHORIZED,
  SESSION_STORAGE_KEYS.NOT_AUTHORIZED_DIALOG,
];

export const TRANSLATION_STORAGE_KEY = "_translations";

i18n.use(initReactI18next).init({
  resources: {
    en: enResources,
    translation: {
      ...JSON.parse(sessionStorage.getItem(TRANSLATION_STORAGE_KEY) || "{}"),
    },
  },
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    bindI18nStore: "added",
  },
});

export default i18n;
